import logo from './logo.svg';
import './App.css';
import Gst from "./Gst";
function App() {
  return (
    <Gst/>
  );
}

export default App;
